<template>
    <div class='footer'>
       <div class="footer-content">
           <div class="footer-content-info">
                <div class="content-info-text">
                    <div>
                        <span><img src="../../assets/images/index/address_icon.png"/>广州市东风中路越秀城市广场南塔10~12楼</span>
                        <span><img src="../../assets/images/index/phone.png"/>020-83183060</span>
                        <span><img src="../../assets/images/index/email_icon.png"/>guangzgzc@gz.com</span>
                        <span><img src="../../assets/images/index/artisan_icon.png"/>技术支持：<a href="https://www.xcontract.cn">北京智签科技有限公司</a></span>
                        <span><img src="../../assets/images/index/phone.png"/>技术支持电话：199-2600-3061</span>
                        <p class="footer-Record-no">
                            2024 All Right Resvered&nbsp;&nbsp;广州公证处版权所有&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn">粤ICP备15104773号</a>
                            <!-- <img src="../../assets/images/index/police_badge.png"/>&nbsp;&nbsp;粤公网安备 33010602005151号 -->
                        </p>
                    </div>
                </div>        
                <div class="content-info-code">
<!--                    <p>-->
<!--                      <img src="../../assets/images/index/app_code.png"/>-->
<!--                      <span>关注赋强公证小程序</span>-->
<!--                    </p>-->
                    <p>
                      <img src="../../assets/images/index/wxgzh.png"/>
                      <span>扫码关注微信公众号</span>
                    </p>
                </div>
           </div>
         
       </div>
    </div>
</template>

<script>
export default {
	name:'FooterArea'
}
</script>

<style scoped lang="scss">
/* footer */
.footer {
    width: 100%;
    height: 327px;
    text-align: left;
    color:#fff;
    background:#332929 ;
}
.footer-content{
    width: 1200px;
    margin: 0 auto;
    .footer-content-info{
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-top:50px;
        .content-info-text{
            color: #D8D8D8;
            display: flex;
             padding:48px 0px 20px 0px; 
            div:nth-child(2){
                margin-left: 59px;
            }
            span{
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                display: block;
                margin-bottom: 10px;
                img{
                    float: left;
                    width: 16px;
                    height: 16px;
                    margin-right:3px;
                }
            }
            .footer-Record-no{
                font-size: 12px;
                font-weight: 500;
                display: flex;
                align-items: center;
                padding-top:37px; 
                img{
                    width: 18px;
                    height: 18px;
                    margin-left: 2px;
                }
                
            }
            a {
                color: #D8D8D8;
                text-decoration: underline;
            }
        }
        .content-info-code{
            display: flex;
            height: 100%;
            justify-content: space-between;
            align-items: center;
            width: 130px;
            margin-top: 50px;
            p{
                width: 130px;
                text-align: center;
                img{
                    width: 130px;
                    height: 130px;
                    display: inline-block;
                }
                span{
                    font-size: 12px;
                    font-weight: 500;
                    color: #FFFFFF;
                }
            }
        }
    }
}
</style>
